import { useQuery, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { userList } from 'services/apiUsers';

const useUserlist = (page=1,size=10,searchTerm,orgFilter) => {

    const queryClient = useQueryClient();
    const {isPending, isSuccess, isError, error, data} = useQuery({
        queryKey:['userList',page,size,searchTerm,orgFilter],
        queryFn:()=> userList(page,size,searchTerm,orgFilter),
        keepPreviousData:true,
        staleTime:  2 * 60 * 60 * 1000
    })

    return{isPending, isSuccess, isError, error, data}
}

export default useUserlist